import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * V2 PeriodSelector — 4 chips (today / yesterday / week / month).
 * Drives the period state of the pilotage page.
 * NoiRock dark theme (R6 — no Black-Ads hardcodes).
 */
export const PERIODS = ['today', 'yesterday', 'week', 'month'];

const PeriodSelector = ({ value, onChange, className = '' }) => {
  const { t } = useTranslation();
  return (
    <div className={`inline-flex rounded-lg overflow-hidden border border-border bg-card flex-shrink-0 ${className}`}>
      {PERIODS.map((key) => {
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className={`px-3 md:px-4 py-2 text-xs md:text-sm font-medium transition-colors ${
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
          >
            {t(`adminV2.periods.${key}`, key)}
          </button>
        );
      })}
    </div>
  );
};

export default PeriodSelector;
